import React from "react";
import {
  CommercialPage,
  PageIntro,
  ContactCTA,
  ProcessSteps,
} from "../components/commercial";
import { commercialMetadata } from "./commercial-metadata";
const steps = [
  [
    "Qualification Call",
    "Understand the problem at a high level, establish mutual fit and collect initial context. If there is no fit, the opportunity closes here.",
    "Free · One call · Up to 30 minutes",
  ],
  [
    "Engineering Assessment",
    "Every continuing opportunity starts with paid project-definition work before the implementation Proposal/quotation, including simple or already-understood projects.",
    "Paid · Starting at US$100",
  ],
  [
    "Proposal / quotation",
    "Using the Assessment results, we present the approach, expected outcomes, major deliverables, project structure, schedule and investment.",
  ],
  [
    "Commercial acceptance",
    "You decide whether to proceed with the proposed commercial and technical direction.",
  ],
  [
    "Statement of Work",
    "After commercial acceptance, we define scope, deliverables, exclusions, acceptance criteria, responsibilities, packages and project-specific terms.",
  ],
  [
    "Approval + payment / kickoff conditions",
    "The SOW is approved and the applicable payment and kickoff requirements are satisfied. Normally, each engineering package is paid before its execution begins.",
  ],
  [
    "Engineering execution",
    "Quantingo takes technical ownership of the contracted work through implementation, integration, validation and applicable deployment or handover. Packages deliver defined engineering outcomes.",
  ],
];
export default function HowWeWork() {
  return (
    <CommercialPage meta={commercialMetadata["how-we-work"]}>
      <PageIntro
        label="How we work"
        title="From engineering problem to working system."
      >
        Understand what needs to be achieved, reduce the important
        uncertainties, define the right project, and deliver it. You can start
        without a complete specification.
      </PageIntro>
      <section className="section services-section">
        <div className="container about-grid">
          <div>
            <p className="eyebrow">A clear path</p>
            <h2>Define the work before implementation begins.</h2>
            <p className="page-copy">
              The Assessment scope and document detail stay proportional to the
              problem. Projects are structured around meaningful outcomes,
              rather than open-ended allocations of developer hours.
            </p>
          </div>
          <ProcessSteps steps={steps} />
        </div>
      </section>
      <section className="section container about-grid">
        <div>
          <p className="eyebrow">The value of assessment</p>
          <h2>An engineering result of its own.</h2>
        </div>
        <div className="page-prose">
          <p>
            Engineering Assessment is a paid engineering engagement with an
            agreed purpose, boundaries, and price.
          </p>
          <p>
            Assessment pricing starts at US$100 and increases according to the
            work required. It may include reviewing relevant code or
            architecture, reproducing a failure, validating feasibility,
            investigating constraints, or defining integration and
            implementation boundaries.
          </p>
          <p>
            The result reduces uncertainty and establishes the engineering and
            commercial basis for the implementation Proposal, including scope,
            approach, estimates and pricing. There is no obligation to proceed
            to implementation.
          </p>
          <p>
            The free Qualification Call does not include technical
            investigation, code review, architecture analysis, solution design,
            detailed scoping, effort estimation, pricing, or Proposal, SOW or
            quotation preparation. There is no additional free qualification
            work after the call.
          </p>
        </div>
      </section>
      <section className="section services-section">
        <div className="container">
          <div className="section-heading">
            <div>
              <p className="eyebrow">During the project</p>
              <h2>Visibility without unnecessary overhead.</h2>
            </div>
          </div>
          <div className="work-grid">
            {[
              [
                "Direct communication",
                "We agree a communication rhythm that fits the engagement: concise updates, asynchronous discussion or alignment meetings. You see outcomes, material risks, decisions and next steps.",
              ],
              [
                "Explicit delivery and scope",
                "Packages have defined deliverables and acceptance criteria where appropriate. Verified nonconformities within scope are addressed; new requirements are evaluated explicitly as scope changes.",
              ],
              [
                "A clear completion point",
                "Validation, documentation, deployment, handover and post-delivery support follow the agreed scope. Ongoing maintenance, support or further engineering can be contracted separately.",
              ],
            ].map(([title, copy]) => (
              <article className="work-card page-prose" key={title}>
                <h3>{title}</h3>
                <p>{copy}</p>
              </article>
            ))}
          </div>
          <p className="page-copy">
            We identify client dependencies such as system access,
            documentation, hardware, test environments and timely decisions.
            When additional specialists are needed, Quantingo remains
            responsible for contracted delivery and technical coordination.
          </p>
        </div>
      </section>
      <ContactCTA
        title="Start with the problem."
        label="Start with a qualification call"
      >
        Tell us what you want to accomplish, what exists today, or what
        uncertainty is preventing you from moving forward.
      </ContactCTA>
    </CommercialPage>
  );
}
